import clsx from 'clsx';

interface YoutubeProps {
  className?: string;
}

const Youtube: React.FC<YoutubeProps> = ({ className }) => {
  return (
    <svg
      className={clsx('youtube', className)}
      fill="none"
      height="124"
      viewBox="0 0 172 124"
      width="172"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect fill="white" height="123" rx="7.5" width="171" x="0.5" y="0.5" />
      <rect height="123" rx="7.5" stroke="#D1D2D4" width="171" x="0.5" y="0.5" />
      <rect fill="#FFECEE" height="88" width="156" x="8" y="12" />
      <path
        d="M86.0767 46.998C86.0853 46.9981 86.0945 46.9981 86.1043 46.9981L86.2105 46.9984C87.4432 47.003 93.6909 47.0483 95.3754 47.5011C96.408 47.7781 97.2212 48.5943 97.4972 49.6304C97.6491 50.1997 97.755 50.9563 97.8288 51.7344L97.8431 51.8903C97.8547 52.0203 97.8655 52.1506 97.8754 52.2805L97.8869 52.436C97.9855 53.8072 97.997 55.0903 97.9984 55.371L97.9985 55.4089C97.9985 55.412 97.9985 55.4171 97.9985 55.4171V55.4383C97.9985 55.4383 97.9985 55.4434 97.9985 55.4465L97.9984 55.4844C97.997 55.7757 97.9846 57.1466 97.8754 58.575L97.8631 58.731L97.85 58.8872C97.7757 59.7461 97.6643 60.5989 97.4972 61.225C97.2212 62.2611 96.408 63.0775 95.3754 63.3543C93.6347 63.8224 87.0216 63.8552 86.1043 63.8575L86.0337 63.8577C86.0279 63.8577 86.0228 63.8577 86.0184 63.8577L85.9896 63.8577C85.9896 63.8577 85.983 63.8577 85.9786 63.8577L85.8927 63.8575C85.4291 63.8564 83.5108 63.8474 81.5019 63.7784L81.2451 63.7693C81.2022 63.7677 81.1594 63.7661 81.1165 63.7645L80.8594 63.7543L80.6028 63.7434C78.9386 63.6704 77.3518 63.5506 76.6218 63.3543C75.5892 63.0775 74.7761 62.2611 74.5001 61.225C74.3329 60.5989 74.2214 59.7461 74.1471 58.8872L74.134 58.731L74.1217 58.575C74.0164 57.1985 74.0011 55.8755 73.9988 55.5204L73.9986 55.4696C73.9986 55.465 73.9985 55.4608 73.9985 55.4569V55.3985C73.9985 55.3946 73.9986 55.3904 73.9986 55.3859L73.9988 55.335C74.0009 55.0134 74.0136 53.898 74.0942 52.6679L74.1046 52.5136C74.1064 52.4878 74.1083 52.4619 74.1101 52.436L74.1217 52.2805C74.1316 52.1506 74.1423 52.0203 74.154 51.8903L74.1683 51.7344C74.2421 50.9563 74.3481 50.1997 74.5001 49.6304C74.7761 48.5943 75.5892 47.7781 76.6218 47.5011C77.3518 47.3049 78.9386 47.1852 80.6028 47.1122L80.8594 47.1013L81.1165 47.0911C81.1594 47.0895 81.2022 47.0879 81.2451 47.0863L81.5019 47.0772C83.3826 47.0126 85.1839 47.0007 85.7865 46.9984L85.8927 46.9981C85.9026 46.9981 85.9118 46.9981 85.9203 46.998H86.0767ZM83.5986 51.8148V59.0406L89.8337 55.4279L83.5986 51.8148Z"
        fill="#F70103"
      />
      <path
        d="M21.5964 110.697L15.2328 114.388C14.6925 114.702 14 114.323 14 113.692V106.308C14 105.678 14.6925 105.299 15.2328 105.612L21.5964 109.304C22.1345 109.616 22.1345 110.384 21.5964 110.697Z"
        fill="#B9BABE"
      />
      <path
        d="M32.125 106C32.7463 106 33.25 106.597 33.25 107.333V112.667C33.25 113.403 32.7463 114 32.125 114C31.5037 114 31 113.403 31 112.667V107.333C31 106.597 31.5037 106 32.125 106Z"
        fill="#B9BABE"
      />
      <path
        d="M35.875 106C36.4963 106 37 106.597 37 107.333V112.667C37 113.403 36.4963 114 35.875 114C35.2537 114 34.75 113.403 34.75 112.667V107.333C34.75 106.597 35.2537 106 35.875 106Z"
        fill="#B9BABE"
      />
    </svg>
  );
};


export default Youtube;
